/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vendor_Return_Status_RequestedInputs */

const en_vendor_return_status_requested = /** @type {(inputs: Vendor_Return_Status_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for the supplier`)
};

/**
* | output |
* | --- |
* | "Waiting for the supplier" |
*
* @param {Vendor_Return_Status_RequestedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_status_requested = /** @type {((inputs?: Vendor_Return_Status_RequestedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Status_RequestedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_status_requested(inputs)
});